export type ProfileLink = {
  id: string;
  title: string;
  helper: string;
  href: string;
  icon: string;
};

export type SocialLink = {
  id: string;
  label: string;
  href: string;
  icon: string;
};

export type ContactFormConfig = {
  title: string;
  nameLabel: string;
  namePlaceholder: string;
  phoneLabel: string;
  phonePlaceholder: string;
  terms: string;
  submitLabel: string;
  leadEndpoint: string;
  whatsappBaseUrl: string;
  messageIntro: string;
};

export type BioProfile = {
  name: string;
  description: string;
  logo: string;
  colors: {
    background: string;
    surface: string;
    text: string;
    muted: string;
    accent: string;
    beam: string;
    border: string;
  };
  contactForm: ContactFormConfig;
  links: ProfileLink[];
  socials: SocialLink[];
  seo: {
    title: string;
    description: string;
    image: string;
  };
  footer: string;
};

export const profile: BioProfile = {
  name: '2Players Marketing',
  description: 'Marketing, tecnologia e direção estratégica para marcas que querem crescer com presença.',
  logo: '/logo-2players-marca-crop.png',
  colors: {
    background: '#F8F8F8',
    surface: '#FFFFFF',
    text: '#161616',
    muted: '#737373',
    accent: '#D11A2A',
    beam: '#E9B44C',
    border: 'rgba(22, 22, 22, 0.10)'
  },
  contactForm: {
    title: 'Informe seus dados para contato',
    nameLabel: 'Nome',
    namePlaceholder: 'Seu nome',
    phoneLabel: 'Telefone',
    phonePlaceholder: '(00) 00000-0000',
    terms:
      'Ao preencher e enviar este formulário, você concorda em compartilhar seus dados com o proprietário deste perfil para retorno de contato.',
    submitLabel: 'Enviar',
    leadEndpoint: '/api/leads',
    whatsappBaseUrl: 'https://wa.me/5527999958722',
    messageIntro: 'Olá! Preenchi o formulário do biolink da 2Players Marketing.'
  },
  links: [
    {
      id: 'whatsapp',
      title: 'WhatsApp',
      helper: 'Solicite um orçamento',
      href: 'https://wa.me/5527999958722?text=Quero%20solicitar%20um%20or%C3%A7amento%20com%20a%202Players%20Marketing',
      icon: 'MessageCircle'
    },
    {
      id: 'instagram',
      title: 'Instagram',
      helper: 'Acompanhe nossos projetos',
      href: 'https://www.instagram.com/2playersmarketing',
      icon: 'Instagram'
    },
    {
      id: 'tiktok',
      title: 'TikTok',
      helper: 'Conteúdos e bastidores',
      href: 'https://www.tiktok.com/@2playersmarketing',
      icon: 'Music2'
    },
    {
      id: 'youtube',
      title: 'YouTube',
      helper: 'Marketing e tecnologia',
      href: 'https://www.youtube.com/@2playersMKT',
      icon: 'Youtube'
    },
    {
      id: 'facebook',
      title: 'Facebook',
      helper: 'Acompanhe nossas novidades',
      href: 'https://www.facebook.com/profile.php?id=61591529940141',
      icon: 'Facebook'
    },
    {
      id: 'email',
      title: 'Email',
      helper: 'Envie sua mensagem',
      href: 'mailto:2playersmarketing@gmail.com',
      icon: 'Mail'
    },
    {
      id: 'website',
      title: 'Website',
      helper: 'Acesse nosso site',
      href: 'https://2players.com.br',
      icon: 'Globe2'
    }
  ],
  socials: [
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      href: 'https://wa.me/5527999958722?text=Quero%20solicitar%20um%20or%C3%A7amento%20com%20a%202Players%20Marketing',
      icon: 'MessageCircle'
    },
    {
      id: 'instagram',
      label: 'Instagram',
      href: 'https://www.instagram.com/2playersmarketing',
      icon: 'Instagram'
    },
    {
      id: 'tiktok',
      label: 'TikTok',
      href: 'https://www.tiktok.com/@2playersmarketing',
      icon: 'Music2'
    },
    {
      id: 'youtube',
      label: 'YouTube',
      href: 'https://www.youtube.com/@2playersMKT',
      icon: 'Youtube'
    },
    {
      id: 'facebook',
      label: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=61591529940141',
      icon: 'Facebook'
    },
    {
      id: 'email',
      label: 'Email',
      href: 'mailto:2playersmarketing@gmail.com',
      icon: 'Mail'
    },
    {
      id: 'website',
      label: 'Website',
      href: 'https://2players.com.br',
      icon: 'Globe2'
    }
  ],
  seo: {
    title: '2Players Marketing | Biolink',
    description: 'Links oficiais da 2Players Marketing.',
    image: '/logo-2players-marca.png'
  },
  footer: '© 2026 2Players Marketing'
};
